import { deleteUser, updateUser } from '@store/UserReducer'
import { SBRM, SBRMForm } from '@supplement-bacon/sbrm-react'
import { forwardRef } from 'react'
import { useAppDispatch, useAppSelector } from '../../../store/hooks'
import Delete from './Delete'
import Update from './Update'

export const UserForm: SBRMForm = forwardRef(({ formProps }, ref) => {
  const dispatch = useAppDispatch()
  const { error } = useAppSelector((state) => state.user)

  return (
    <SBRM.BaseEntityForm
      {...{ ref, formProps }}
      error={error && String(error)}
      formActions={{
        update: Update,
        delete: Delete,
      }}
      handlers={{
        update: async (values) =>
          dispatch(updateUser(values)).then(() => {
            return true
          }),
        delete: async (values) =>
          dispatch(deleteUser(values)).then(() => {
            return true
          }),
      }}
    />
  )
})

UserForm.displayName = 'UserForm'

export default UserForm
